import { Label } from "@/components/label";
import { Switch } from "@/components/switch";
import type { ExtractionNode } from "@repo/shared/workflow";
import type { FC } from "react";

interface ExtractionNodeEditorProps {
  node: ExtractionNode;
  onChange: (key: string, value: unknown) => void;
}

export const ExtractionNodeEditor: FC<ExtractionNodeEditorProps> = ({
  node,
  onChange,
}) => {
  const { showDescription } = node;

  // Simplifying for demo purposes - in a real app you would have a more complex
  // model editor component here to handle the model structure
  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2 py-2">
        <Switch
          id="showDescription"
          checked={showDescription === true}
          onCheckedChange={(checked) => onChange("showDescription", checked)}
        />
        <Label htmlFor="showDescription">Show Description</Label>
      </div>
      {/* Model here */}
    </div>
  );
};
